import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiCall } from '../api/client';
import { toast } from 'sonner';

export default function ContractorDashboard() {
  const queryClient = useQueryClient();
  const { data: matches, isLoading } = useQuery({
    queryKey: ['my-matches'],
    queryFn: () => apiCall<any[]>('/matches'),
    refetchInterval: 15000,
  });

  const respondMutation = useMutation({
    mutationFn: ({ matchId, status }: { matchId: string; status: string }) =>
      apiCall(`/matches/${matchId}/respond`, { method: 'POST', body: JSON.stringify({ status }) }),
    onSuccess: () => { queryClient.invalidateQueries({ queryKey: ['my-matches'] }); toast.success('Response sent!'); },
  });

  return (
    <div className="page">
      <h1 style={{ fontSize: '1.6rem', fontWeight: 700, marginBottom: 'var(--space-xl)' }}>Incoming Work Orders</h1>

      {isLoading ? (
        <div style={{ textAlign: 'center', padding: 48 }}><div className="doe-spinner" style={{ margin: '0 auto' }} /></div>
      ) : !matches?.data?.length ? (
        <div className="card" style={{ textAlign: 'center', padding: 48 }}>
          <p style={{ fontSize: '3rem', marginBottom: 16 }}>📭</p>
          <h2 style={{ fontWeight: 600, marginBottom: 8 }}>No incoming requests</h2>
          <p style={{ opacity: 0.7 }}>Make sure your status is set to Online to receive work orders.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: 'var(--space-md)' }}>
          {matches.data.map((match: any) => (
            <div key={match.id} className="card">
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-md)', marginBottom: 'var(--space-md)' }}>
                <div style={{ fontSize: '2rem' }}>{match.trade_icon || '🔨'}</div>
                <div style={{ flex: 1 }}>
                  <h3 style={{ fontWeight: 600 }}>{match.trade_name} — {match.problem_label || 'General'}</h3>
                  <p style={{ fontSize: '0.85rem', opacity: 0.7 }}>{match.description || 'No details provided'}</p>
                  <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                    <span className={`badge urgency-${match.urgency?.replace('_', '-')}`}>{match.urgency}</span>
                    <span className="badge badge-pending">{match.budget_range?.replace('_', '-')}</span>
                    {match.distance_miles && <span className="badge badge-offline">{match.distance_miles} mi</span>}
                  </div>
                </div>
              </div>

              {match.ai_baseline && (
                <div className="disclaimer" style={{ marginBottom: 'var(--space-md)' }}>
                  AI Estimated Price: ${match.ai_baseline.avg_price} (range: ${match.ai_baseline.min_price}–${match.ai_baseline.max_price}) — {match.disclaimer}
                </div>
              )}

              <div style={{ display: 'flex', gap: 'var(--space-md)' }}>
                <button className="btn-primary" onClick={() => respondMutation.mutate({ matchId: match.id, status: 'accepted' })} disabled={respondMutation.isPending}>
                  Accept Job
                </button>
                <button className="chip" onClick={() => respondMutation.mutate({ matchId: match.id, status: 'declined' })} disabled={respondMutation.isPending}>
                  Decline
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
